require('./optionGroup.i18n.json');
require('./optionGroup.tpl.html');
require('./optionGroupController.js');
require('./optionGroupButton/optionGroupButtonComponent.js');
require('./optionGroupCheckbox/optionGroupCheckboxComponent.js');
require('./optionGroupDropDown/optionGroupDropDownComponent.js');
require('./optionGroupMultiSelect/optionGroupMultiSelectComponent.js');
require('./optionGroupRadioButtons/optionGroupRadioButtonsComponent.js');
require('./optionGroupTextInput/optionGroupTextInputComponent.js');

const OptionGroupComponent = {
    templateUrl: '/configuration/formEditor/content/form/componentSettings/optionGroup/optionGroup.tpl.html',
    controller: 'optionGroupController',
    bindings: {
        selectedField: '<',
        selectedFieldStructure: '<',
        optionGroupName: '<',
        displayHeader: '<',
        headerTitleKey: '<',
        settings: '<',
        scrollableContainerSelector: '<'
    }
};

angular.module('ums.configuration')
    .component('uiOptionGroup', OptionGroupComponent);
